'use client';
export { Flex } from '@chakra-ui/react';

//# sourceMappingURL=index.js.map